<template>
  <div class="card modal-card-panier modal-card-border">
    <div class="card-content">
      <section>
        <p class="subtitle is-5">Le panier sera supprimé et remplacé par cette opportunité.</p>
      </section>
      <br>
      <footer>
        <div class="has-text-centered">
          <button class="button is-gris button-modal has-text-centered"
                  @click="$emit('close')">
            Annuler
          </button>
          <button class="button is-primary button-modal has-text-centered"
                  @click="rechargerOpportunite(); $emit('close')">
            Continuer
          </button>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { SET_IS_DUPLICATE, SET_IS_MODIF } from '@/store/creationOpportunite/panier-mutation-type';

const Panier = createNamespacedHelpers('panier');

export default {
  name: 'confirmation-mail',
  props: ['opportuniteId', 'type'],
  computed: {
    ...Panier.mapGetters({
      destinataires: 'destinataires',
      getThemeCampagne: 'themeCampagne',
      getDateValidite: 'dateValidite',
      getPanier: 'panier',
      getClientPanier: 'clientPanier',
    }),
  },
  methods: {
    ...Panier.mapActions({
      actionsRechargerOpportunite: 'rechargerOpportunite',
    }),
    ...Panier.mapMutations({
      actionsSetIsDuplicate: SET_IS_DUPLICATE,
      actionsSetIsModif: SET_IS_MODIF,
    }),
    async rechargerOpportunite() {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      if (this.type === 'modif') {
        this.actionsSetIsModif(true);
        this.actionsSetIsDuplicate(false);
      }
      if (this.type === 'duplicate') {
        this.actionsSetIsDuplicate(true);
        this.actionsSetIsModif(false);
      }
      await this.actionsRechargerOpportunite(this.opportuniteId);
      loadingComponent.close();
      this.$router.push('/panier');
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/mesOpportunites/recherche/copierOpportunite.vue